import { IconTrash } from '@tabler/icons-react'
import { useState } from 'react'

import { AstraButton, AstraHeading, AstraIcon, AstraParagraph, AstraPopover } from '~/astra'
import { archiveRecurringAssignment } from '~/store/di-entity.api'
import { RecurringAssignmentType } from '~/storm'

type Props = {
    assignment: RecurringAssignmentType
}

export const DeleteAssignment = ({ assignment }: Props) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleDelete = () => {
        void archiveRecurringAssignment(assignment.uuid)
        setIsOpen(false)
    }

    return (
        <AstraPopover
            isOpen={isOpen}
            align="end"
            className="z-priority"
            onOpenChange={setIsOpen}
            popoverContent={
                <div className="flex max-w-md flex-col gap-2 p-2">
                    <AstraHeading as="h2" className="truncate">
                        Bekreft sletting
                    </AstraHeading>
                    <AstraParagraph weight="regular" variant="body">
                        Er du sikker på at du vil slette regel "{assignment.title}"?
                    </AstraParagraph>
                    <div className="flex justify-end gap-2">
                        <AstraButton onClick={() => setIsOpen(false)} variant="secondary" size="medium" autoFocus label={'Avbryt'} />
                        <AstraButton onClick={handleDelete} variant="critical" size="medium" data-test="alert-dialog-confirm" label={'Slett'} />
                    </div>
                </div>
            }
        >
            <AstraButton icon={<AstraIcon icon={IconTrash} size="medium" />} variant="ghost" size="large" onClick={() => setIsOpen(true)} />
        </AstraPopover>
    )
}
